// extracted by mini-css-extract-plugin
module.exports = {"page":"NewPanelFilter_page__1LUOZ","panel":"NewPanelFilter_panel__3_xcD","filtersTitle":"NewPanelFilter_filtersTitle__7OGE_","filtersToggle":"NewPanelFilter_filtersToggle__Ia4Ye"};